var exports = {
  "DZ": "Heading__6TFjUh",
  "EY": "Text__XKqqY-",
  "Ou": "UnderlineNav__Gz4dLx",
};

module.exports = exports;
